import { SystemSpaceSlug } from '@bettermode/common/space'
import { useI18n } from '@tribeplatform/react-components/i18n'
import { useRouter, useRouterPath } from '@tribeplatform/react-sdk'
import { useSpaceUtil } from '@tribeplatform/react-sdk/hooks'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { NavVertical } from '@tribeplatform/react-ui-kit/Sidebar'

import { useSlate } from '../../hooks/slate.hook.js'
import { useMobileMenu } from '../Navbar/providers/MobileMenuProvider.js'

import { CollectionMenuSpaces } from './CollectionMenuSpaces.js'
import {
  CollectionMenuEntry,
  getCollectionMenuEntrySpaces,
  isNoCollectionEntry,
} from './types.js'

export const CollectionMenuSimple = ({
  collections,
  ...rest
}: {
  collections: CollectionMenuEntry[]
}) => {
  const { Link } = useRouter()
  const { close } = useMobileMenu()
  const { generatePath, matchPath } = useSpaceUtil()
  const pathname = useRouterPath()
  const { mode } = useSlate()
  const isPreviewMode = mode !== 'live'
  const { localeCode } = useI18n()

  return (
    <NavVertical {...rest}>
      <div className="space-y-2">
        {collections.map(collection => {
          const spaces = getCollectionMenuEntrySpaces(collection, localeCode)

          if (isNoCollectionEntry(collection)) {
            return (
              <NavVertical.Group key={collection.id}>
                <CollectionMenuSpaces spaces={spaces} />
              </NavVertical.Group>
            )
          }

          const hasSpaces = collection?.spaces?.totalCount
          const isActive = matchPath(SystemSpaceSlug.COLLECTION, pathname, {
            id: collection.id,
          })

          if (!hasSpaces) {
            return null
          }

          return (
            <NavVertical.Group key={collection.id}>
              <NavVertical.Item
                // className="group"
                active={!!isActive}
                as={Link}
                href={generatePath(SystemSpaceSlug.COLLECTION, {
                  id: collection.id,
                })}
                leadingIcon={<SvgIcon name="grid" />}
                onClick={e => {
                  if (isPreviewMode) {
                    e.preventDefault()
                    return
                  }

                  close()
                }}
              >
                <span className="truncate flex-grow font-semibold text-sm text-content-on-background-subdued">
                  {collection.name}
                </span>
              </NavVertical.Item>
            </NavVertical.Group>
          )
        })}
      </div>
    </NavVertical>
  )
}
